import { Injectable, NgModule, ErrorHandler } from '@angular/core';
import { ErrorTracking } from './error-tracking.service';

@Injectable()
export class CustomErrorHandler implements ErrorHandler {
  constructor(private errorTracking: ErrorTracking) {}

  handleError(error: Error): void {
    this.errorTracking.captureException(error);
  }
}



// WEBPACK FOOTER //
// ./src/app/@shared/tracking/custom-error-handler.service.ts